/**
 * The feedback filter enums the two route search schemas need, in a module
 * that imports nothing.
 *
 * Same bundle decision as `offer-vocabulary.ts`: `router.tsx` imports every
 * route's `validateSearch` schema EAGERLY, so what a search module reaches for
 * lands in the initial chunk. `feedback.route.search.ts` and
 * `admin-feedback.route.search.ts` between them needed four small enums, and
 * both were reaching into `schemas/feedback.schema.ts`, a 230-line module of
 * wire rows, create/edit/acknowledge inputs and action-plan schemas.
 *
 * The tuples are the single source of truth: `feedback.schema.ts` builds its
 * Zod enums from them, so the URL parser and the wire parser cannot drift.
 */

export const FEEDBACK_SEVERITIES = ["low", "medium", "high"] as const;
export type FeedbackSeverityName = (typeof FEEDBACK_SEVERITIES)[number];

export const FEEDBACK_ROLE_FILTERS = ["author", "recipient", "both"] as const;
export type FeedbackRoleFilterName = (typeof FEEDBACK_ROLE_FILTERS)[number];

export const FEEDBACK_STATUS_FILTERS = ["acknowledged", "unacknowledged"] as const;
export type FeedbackStatusFilterName = (typeof FEEDBACK_STATUS_FILTERS)[number];

export const FEEDBACK_ANALYSIS_STATUSES = ["unanalyzed", "pending", "analyzed", "failed"] as const;
export type FeedbackAnalysisStatusName = (typeof FEEDBACK_ANALYSIS_STATUSES)[number];
